let cache: { version: string | undefined } | undefined;

export default function getHeyloginVersion(): string | undefined {
  if (!cache) {
    cache = {
      // this meta element is injected into the build html as part of the postprocessing in CI
      version: document.querySelector<HTMLMetaElement>('meta[name=application-version]')?.content,
    };
  }
  return cache.version;
}
